export const QUERY_ROUTE_TRACKING_GET_TEAM_SALE = `query  GetSalePlanningByTeam($input: SalePlanningByTeamInput, $skip: Float, $take: Float){
    getSalePlanningByTeam(where: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            salePlanningId
            customerWasCare
            remainingCustomers
            expectedRevenue
            implementationDate
            tripId
            tripName
            troute{
                id
                name
            }
            tsaleStatus{
                id
                name
            }
            tteamSales{
                id
                subId
                name
            }
        }
    }
}`;

export const QUERY_ROUTE_TRACKING_GET_LOCATION_TEAM_SALE = `query GetLocationTeamSaleByPlant($input: LocationTeamSaleByPlantInput){
    getLocationTeamSaleByPlant(where: $input){
        totalTeamSale
        expectedRevenue
        revenueRealized
        ratioRevenueRealized
        totalCustomer
        totalProductPrice
        totalProcessPrice
        totalCaseCustomer
        totalProcessPriceSap
        tteamSale{
            id
            subId
            name
            latitude
            longitude            
        }
    }
}`;

export const QUERY_GET_LOCATION_CUSTOMER_BY_TEAM_SALE = `query GetLocationTeamSaleInPlantByTeamSale($input: LocationTeamSaleBySalePlanningInput){
    getLocationTeamSaleInPlantByTeamSale(where: $input){
        teamSalesId
        teamSalesSubId
        teamSalesName
        expectedRevenue
        radioExpectedRevenues
        totalProcessPrice
        totalProductPrice
        totalCustomer
        totalCaseCustomer
        totalProcessPriceSap
        tteamSale{
            id
            longitude
            latitude
            name
            subId
        }
        tsalePlanningCust{
            id
            indexNum
            averageRevenue
            customer{
                id
                sapCustomerId
                storeName
                latitude
                longitude
                expectedRevenue
            }
            tcheckinout{
                id
                checkInTime
                checkOutTime
                totalProcessPrice
                totalProductPrice
            }
            tprocessStatus{
                id
                name
            }
        }
       
    }
}`;

export const QUERY_GET_STATUS_SALE_PLANNING = `query GetStatusSalePlanning($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}`;
